<template>
  <div class="logout-drawer-container">
    <!-- 触发按钮 -->
    <button class="trigger-btn glass-trigger" @click="toggleDrawer">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <defs>
          <filter id="triggerGlassFilter">
            <feGaussianBlur in="SourceGraphic" stdDeviation="1"/>
            <feColorMatrix type="matrix" values="1 0 0 0 0.2  0 1 0 0 0.2  0 0 1 0 0.2  0 0 0 0.2 0"/>
          </filter>
        </defs>
        <circle cx="12" cy="12" r="10" fill="rgba(255,255,255,0.15)" filter="url(#triggerGlassFilter)"/>
        <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="white" stroke-width="2"/>
        <path d="M16 17L21 12L16 7" stroke="white" stroke-width="2" stroke-linecap="round"/>
        <path d="M21 12H9" stroke="white" stroke-width="2"/>
      </svg>
      <span>{{ $i18n.t("subscription.logout") }}</span>
    </button>

    <!-- 抽屉遮罩 -->
    <div v-if="isOpen" class="drawer-overlay" @click="toggleDrawer"></div>

    <!-- 抽屉内容 -->
    <div class="drawer" :class="{ 'drawer-open': isOpen }">
      <div class="drawer-content">
        <!-- 抽屉头部 -->
        <div class="drawer-header">
          <h3>{{ $i18n.t("subscription.logout_confirm") }}</h3>
          <!-- <button class="close-btn" @click="toggleDrawer">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button> -->
        </div>

        <!-- 抽屉主体 -->
        <div class="drawer-body">
          <div class="user-info">
            <div class="avatar">
              <img :src="user.avatar" alt="User Avatar" v-if="user.avatar">
              <div v-else class="avatar-placeholder">
                {{ user.name ? user.name.charAt(0) : 'U' }}
              </div>
            </div>
            <div class="user-details">
              <p class="username">{{ user.name || 'User' }}</p>
              <p class="email">{{ user.email || 'user@example.com' }}</p>
            </div>
          </div>

          <div class="logout-confirm">
            <p>{{ $i18n.t('main.logout_drawer.text_logout_remind') }}</p>
            <small>{{ $i18n.t('main.logout_drawer.text_logout_remind_two') }}</small>
          </div>
        </div>

        <!-- 抽屉底部 -->
        <div class="drawer-footer">
          <button class="btn-cancel" @click="toggleDrawer">{{ $i18n.t('main.logout_drawer.cancel_btn_txt') }}</button>
          <button class="btn-logout" @click="handleLogout">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" stroke-width="2"/>
              <path d="M16 17L21 12L16 7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path d="M21 12H9" stroke="currentColor" stroke-width="2"/>
            </svg>
            {{ $i18n.t('main.logout_drawer.confirm_btn_txt') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { i18n } from "@/plugins/i18n.js";
import {  userKeys } from "@/service/wd_app_config.js";
export default {
  name: 'LogoutDrawer',
  data() {
    return {
      isOpen: false,
      user: {
        name: JSON.parse(localStorage.getItem(userKeys.key_userObject))?.Name || i18n.t('main.logout_drawer.user.name'),
        email: JSON.parse(localStorage.getItem(userKeys.key_userObject))?.Email || i18n.t('main.logout_drawer.user.email'),
        avatar: ''
      }
    }
  },
  methods: {
    toggleDrawer() {
        console.log(JSON.parse(localStorage.getItem(userKeys.key_userObject)));
      this.isOpen = !this.isOpen
      // 阻止背景滚动
      if (this.isOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
    
    handleLogout() {
      this.$emit('logout')
      
      // 关闭抽屉
      this.toggleDrawer()
      
      // 这里可以添加实际的退出逻辑，如清除token、跳转登录页等
      // this.$store.dispatch('user/logout')
      // this.$router.push('/login')
    }
  },
  
  beforeDestroy() {
    // 组件销毁时恢复滚动
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
.logout-drawer-container {
  position: relative;
}

/* 触发按钮样式 */
.trigger-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.2);
  border-radius: 8px;
  color: #ef4444;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  font-weight: 500;
}

.trigger-btn:hover {
  background: rgba(239, 68, 68, 0.2);
  transform: translateY(-1px);
}
.glass-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  font-weight: 500;
  position: relative;
  overflow: hidden;
}

.glass-trigger::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: left 0.5s;
}

.glass-trigger:hover::before {
  left: 100%;
}

.glass-trigger:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

/* 遮罩层 */
.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  z-index: 998;
}

/* 抽屉样式 */
.drawer {
  position: fixed;
  top: 0;
  right: -400px;
  width: 380px;
  height: 100vh;
  background: white;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.1);
  z-index: 999;
  transition: right 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.drawer-open {
  right: 0;
}

.drawer-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* 抽屉头部 */
.drawer-header {
  display: flex;
  justify-content: between;
  align-items: center;
  padding: 10px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.drawer-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.close-btn {
  padding: 8px;
  border: none;
  background: none;
  border-radius: 6px;
  cursor: pointer;
  color: #6b7280;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background: #f3f4f6;
  color: #374151;
}

/* 抽屉主体 */
.drawer-body {
  flex: 1;
  padding: 24px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 32px;
}

.avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: white;
  font-size: 18px;
}

.avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.user-details .username {
  margin: 0 0 4px 0;
  font-weight: 600;
  color: #1f2937;
}

.user-details .email {
  margin: 0;
  color: #6b7280;
  font-size: 14px;
}

.logout-confirm {
  text-align: center;
  margin-top: 35vh;
  padding: 20px 0;
}

.logout-confirm p {
  margin: 0 0 8px 0;
  font-size: 16px;
  color: #1f2937;
}

.logout-confirm small {
  color: #6b7280;
  font-size: 14px;
}

/* 抽屉底部 */
.drawer-footer {
  display: flex;
  gap: 12px;
  padding: 24px;
  border-top: 1px solid #e5e7eb;
}

.btn-cancel {
  flex: 1;
  padding: 12px;
  border: 1px solid #d1d5db;
  background: white;
  border-radius: 8px;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
}

.btn-cancel:hover {
  background: #f9fafb;
  border-color: #9ca3af;
}

.btn-logout {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  border: none;
  background: #ef4444;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
}

.btn-logout:hover {
  background: #dc2626;
  transform: translateY(-1px);
}

/* 响应式设计 */
@media (max-width: 640px) {
  .drawer {
    width: 100vw;
    right: -100vw;
  }
  
  .drawer-footer {
    flex-direction: column;
  }
}

/* 动画效果 */
.drawer-enter-active,
.drawer-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.drawer-enter-from,
.drawer-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>